import React, {useEffect, useState} from "react";
import {observer} from "mobx-react-lite";
import {useParams} from "react-router-dom";

import appStore from "../../../../storage/AppStore";
import clubStore from "../../../../storage/ClubStore";

import MemberForm from "./MemberForm";
import ParentForm from "./ParentForm";
import StaffForm from "./StaffForm";


const EditCompanyUser = () => {

    const {id} =
        useParams();


    const [
        loading,
        setLoading,
    ] = useState(true);


    const [
        notFound,
        setNotFound,
    ] = useState(false);


    useEffect(() => {

        let active = true;


        const load = async () => {

            setLoading(true);
            setNotFound(false);

            clubStore.resetMember();


            const memberId =
                Number(id);


            if (
                !Number.isInteger(memberId) ||
                memberId <= 0
            ) {
                if (active) {
                    setNotFound(true);
                    setLoading(false);
                }

                return;
            }


            try {

                await clubStore.getMember(
                    memberId
                );


                if (
                    active &&
                    !clubStore.member.id
                ) {
                    setNotFound(true);
                }

            } catch (error) {

                console.error(
                    "--company user load error",
                    error
                );


                if (active) {
                    setNotFound(true);
                }

            } finally {

                if (active) {
                    setLoading(false);
                }
            }
        };


        load();


        return () => {
            active = false;
        };

    }, [id]);


    const member =
        clubStore.member;


    if (loading) {
        return (
            <div className="p-3 text-600">
                {
                    appStore.tr.loading ||
                    "Loading..."
                }
            </div>
        );
    }


    if (
        notFound ||
        !member.id
    ) {
        return (
            <div className="p-3">
                {
                    appStore.tr.record_not_found ||
                    appStore.tr.member_not_found ||
                    "Record not found"
                }
            </div>
        );
    }


    switch (member.role_id) {

        case "MMBR":
            return (
                <MemberForm />
            );


        case "PRNT":
            return (
                <ParentForm />
            );


        default:
            return (
                <StaffForm />
            );
    }
};


export default observer(
    EditCompanyUser
);